import { render, staticRenderFns } from "./Preoperatorio.vue?vue&type=template&id=8234582a&"
import script from "./Preoperatorio.vue?vue&type=script&lang=js&"
export * from "./Preoperatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports